<p-tabs
  [value]="activeIndex()"
  (valueChange)="handleValueChange($event)"
  [scrollable]="scrollable()"
  [class]="styleClass()"
  (onChange)="handleChange($event)">

  <p-tablist>
    <p-tab
      *ngFor="let tab of tabs(); let i = index"
      [value]="i"
      [disabled]="tab.disabled ?? false">
      <i *ngIf="tab.icon" [class]="tab.icon + ' mr-2'"></i>
      {{ headerLabel(tab) }}
    </p-tab>
  </p-tablist>

  <p-tabpanels>
    <p-tabpanel *ngFor="let tab of tabs(); let i = index" [value]="i">
      <ng-container *ngIf="tabContent()" [ngTemplateOutlet]="tabContent()!" [ngTemplateOutletContext]="{ $implicit: tab, index: i }"></ng-container>
    </p-tabpanel>
  </p-tabpanels>

</p-tabs>
